import React, { Component } from "react"
import heroimg from "../assets/images/heroimg.png"
import { withRouter } from "react-router-dom/cjs/react-router-dom.min"
import { routes } from "../../../helper/routes"

class Hero extends Component {
  handleSignUp = () => {
    this.props.history.push(routes.parent_student_signup)
  }

  render() {
    return (
      <>
        <div id="home" className="container">
          <div className="row hero-section-container">
            <div className="col-md-6 hero-container">
              <h1 className="main-heading">ExamOnline</h1>
              <h2 className="sub-heading">Unlock Success with EdSider</h2>
              <p className="paragraph">
                Comprehensive learning material to
                <br />
                succeed in your exams.
              </p>
              {/* <p className="lang-text">5 වසර ශිෂ්‍යත්වය / தரம் 5 உதவித்தொகை</p> */}
              <button type="button" onClick={this.handleSignUp} className="getstarted-btn">Sign Up &#10147;</button>
            </div>

            <div className="col-md-6 hero-container">
              <div className="image-container">
                <img src={heroimg} alt="Image" className="centered-image" />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default withRouter(Hero)
